import React, { useEffect, useRef, Component } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
// Template data for the animated strips
const templateItems = [{
  id: 1,
  image: 'https://images.unsplash.com/photo-1555774698-0b77e0d5fac6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80',
  title: 'Mobile App UI Kit',
  category: 'Mobile App Kits'
}, {
  id: 2,
  image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80',
  title: 'Website Template',
  category: 'Website Templates'
}, {
  id: 3,
  image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80',
  title: 'Dashboard UI',
  category: 'UI Kits'
}, {
  id: 4,
  image: 'https://images.unsplash.com/photo-1611162616475-46b635cb6868?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80',
  title: 'Social Media Pack',
  category: 'Social Media Content Packs'
}, {
  id: 5,
  image: 'https://images.unsplash.com/photo-1636633762833-5d1658f1e29b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80',
  title: 'Brand Identity Kit',
  category: 'Design Systems'
}, {
  id: 6,
  image: 'https://images.unsplash.com/photo-1618788372246-79faff0c3742?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80',
  title: 'E-commerce UI Kit',
  category: 'UI Kits'
}, {
  id: 7,
  image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80',
  title: 'Portfolio Template',
  category: 'Website Templates'
}, {
  id: 8,
  image: 'https://images.unsplash.com/photo-1618788372246-79faff0c3742?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80',
  title: 'Landing Page Kit',
  category: 'Website Templates'
}];
// Template Card component for the animated strips
const TemplateCard = ({
  item
}: {
  item: (typeof templateItems)[0];
}) => {
  return <Link to={`/browse?category=${encodeURIComponent(item.category)}`} data-id="element-1063">
      <motion.div className="w-56 h-32 rounded-lg overflow-hidden shadow-sm dark:shadow-[0_4px_12px_rgba(0,0,0,0.2)] mx-3 flex-shrink-0 relative group cursor-pointer" whileHover={{
      y: -5,
      scale: 1.05,
      transition: {
        duration: 0.2
      }
    }} data-id="element-1064">
        <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-1065" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-end p-3" data-id="element-1066">
          <p className="text-white text-sm font-medium" data-id="element-1067">{item.title}</p>
        </div>
      </motion.div>
    </Link>;
};
// Abstract glow component
const AbstractGlow = ({
  className,
  color
}: {
  className: string;
  color: string;
}) => {
  return <div className={`absolute ${className}`} data-id="element-1068">
      <div className={`w-full h-full rounded-full ${color} blur-3xl opacity-20 blob-animation`} data-id="element-1069"></div>
    </div>;
};
// SVG Blob Component for background decoration
const BlobShape = ({
  className
}: {
  className: string;
}) => {
  return <div className={`absolute ${className}`} data-id="element-1070">
      <svg width="600" height="600" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg" data-id="element-1071">
        <g transform="translate(300,300)" data-id="element-1072">
          <path d="M120,-157.6C152.7,-141.5,174.3,-102.6,184.4,-62.4C194.4,-22.2,192.9,19.2,178.4,54.8C163.9,90.3,136.4,120,103.2,135.6C70,151.2,31,152.6,-5.4,159.8C-41.8,167,-80.5,179.9,-113.2,168C-145.8,156,-172.4,119.1,-185.7,77.7C-198.9,36.2,-198.8,-9.8,-184.5,-50.9C-170.2,-92.1,-141.6,-128.4,-107.3,-143.5C-72.9,-158.7,-32.7,-152.6,5.9,-160.5C44.5,-168.4,87.2,-173.7,120,-157.6Z" fill="url(#blob-gradient)" className="blob-animation" data-id="element-1073" />
        </g>
        <defs data-id="element-1074">
          <linearGradient id="blob-gradient" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-1075">
            <stop offset="0%" stopColor="#0D3C45" stopOpacity="0.15" className="dark:stop-color-[#0B3C45]" data-id="element-1076" />
            <stop offset="100%" stopColor="#2DB489" stopOpacity="0.15" className="dark:stop-color-[#4ED1A0]" data-id="element-1077" />
          </linearGradient>
        </defs>
      </svg>
    </div>;
};
export const Hero = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const circleRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  // Function to navigate to browse products page
  const scrollToProducts = () => {
    navigate('/browse');
  };
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!containerRef.current || !circleRef.current) return;
      const {
        left,
        top,
        width,
        height
      } = containerRef.current.getBoundingClientRect();
      const x = e.clientX - left;
      const y = e.clientY - top;
      // Calculate position relative to container
      const posX = (x / width - 0.5) * 2;
      const posY = (y / height - 0.5) * 2;
      // Move the gradient circle
      circleRef.current.style.transform = `translate(${posX * 20}px, ${posY * 20}px)`;
    };
    const container = containerRef.current;
    if (container) {
      container.addEventListener('mousemove', handleMouseMove);
    }
    return () => {
      if (container) {
        container.removeEventListener('mousemove', handleMouseMove);
      }
    };
  }, []);
  return <section id="hero" ref={containerRef} className="relative w-full flex flex-col items-center justify-center overflow-hidden px-4 pt-20 pb-12 md:py-24 lg:py-32 transition-colors duration-300" data-id="element-1078">
      {/* Abstract shapes background */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-1079">
        {/* Dark mode background shapes */}
        <div className="dark-shape-top-left dark:opacity-100 opacity-0 transition-opacity duration-500" data-id="element-1080"></div>
        <div className="dark-shape-bottom-right dark:opacity-100 opacity-0 transition-opacity duration-500" data-id="element-1081"></div>
        <div className="dark-shape-center dark:opacity-100 opacity-0 transition-opacity duration-500" data-id="element-1082"></div>

        {/* Main gradient blob */}
        <div ref={circleRef} className="absolute w-[800px] h-[800px] rounded-full bg-gradient-to-r from-[#0D3C45]/25 to-[#2DB489]/25 dark:from-[#267A67]/25 dark:to-[#4ED1A0]/25 blur-3xl opacity-60 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-all duration-300 ease-out" data-id="element-1083" />

        {/* Abstract glow shapes */}
        <AbstractGlow className="top-[15%] left-[10%] w-[300px] h-[300px]" color="bg-[#2DB489] dark:bg-[#4ED1A0]" data-id="element-1084" />
        <AbstractGlow className="bottom-[10%] right-[5%] w-[250px] h-[250px]" color="bg-[#0D3C45] dark:bg-[#0B3C45]" data-id="element-1085" />
        <AbstractGlow className="top-[30%] right-[15%] w-[200px] h-[200px]" color="bg-[#2DB489] dark:bg-[#267A67]" data-id="element-1086" />

        {/* Decorative blob shapes */}
        <BlobShape className="top-[10%] left-[5%] w-[400px] h-[400px] opacity-40" data-id="element-1087" />
        <BlobShape className="bottom-[5%] right-[5%] w-[300px] h-[300px] opacity-30" data-id="element-1088" />

        {/* Subtle grid pattern overlay */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiNmZmZmZmYwNSIgZD0iTTM2IDM0aDR2MWgtNHYtMXptMC0yaDF2NGgtMXYtNHptMi0yaDF2MWgtMXYtMXptLTIgMmgxdjFoLTF2LTF6bS0yLTJoMXYxaC0xdi0xem0yLTJoMXYxaC0xdi0xem0tMiAyaDF2MWgtMXYtMXptLTItMmgxdjFoLTF2LTF6bTIgMGgxdjFoLTF2LTF6bS0yIDRoMXYxaC0xdi0xem0yIDBoeDF2MWgtMXYtMXptLTIgMmgxdjFoLTF2LTF6bTQtNGgxdjFoLTF2LTF6Ii8+PC9nPjwvc3ZnPg==')] opacity-30 dark:opacity-20" data-id="element-1089"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto text-center" data-id="element-1090">
        <h1 className="text-2xl sm:text-3xl md:text-6xl lg:text-7xl font-bold mb-3 md:mb-6 bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] text-transparent bg-clip-text leading-tight" data-id="element-1091">
          The Ultimate Marketplace for Digital Products
        </h1>

        <p className="text-sm sm:text-base md:text-xl lg:text-2xl text-[#1F2F35] dark:text-[#C4D1CC] mb-2 md:mb-4 max-w-3xl mx-auto leading-snug" data-id="element-1092">
          Discover premium templates, plugins, and digital assets to elevate
          your projects to the next level.
        </p>

        <p className="text-xs sm:text-sm md:text-lg text-[#4A686C] dark:text-[#7A8F8A] mb-5 md:mb-10 max-w-2xl mx-auto" data-id="element-1093">
          Turn your creativity into income. Sell your digital products globally
          in minutes.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 mb-6 md:mb-12" data-id="element-1094">
          <motion.button onClick={scrollToProducts} className="w-full sm:w-auto bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] text-white px-6 sm:px-8 py-2.5 sm:py-4 rounded-full text-sm sm:text-lg font-medium hover:shadow-xl transition-all transform hover:scale-103 relative overflow-hidden button-hover-effect dark-glow" whileHover={{
          scale: 1.03,
          boxShadow: '0 10px 25px -5px rgba(45, 180, 137, 0.3), 0 10px 10px -5px rgba(45, 180, 137, 0.2)'
        }} whileTap={{
          scale: 0.98
        }} data-id="element-1095">
            <span className="relative z-10" data-id="element-1096">Browse Products</span>
          </motion.button>

          <Link to="/sell-with-us" className="w-full sm:w-auto group relative bg-white dark:bg-transparent text-[#0F3B46] dark:text-[#F8FAF9] border border-gray-200 dark:border-[#267A67] px-6 sm:px-8 py-2.5 sm:py-4 rounded-full text-sm sm:text-lg font-medium hover:border-[#2DB489] dark:hover:border-[#4ED1A0] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-all" data-id="element-1097">
            <span className="relative z-10" data-id="element-1098">Sell With Us</span>
          </Link>
        </div>

        {/* Animated template strip section - Hidden on mobile, shown on tablet+ */}
        <div className="hidden md:block w-full max-w-6xl mx-auto mt-4 mb-12" data-id="element-1099">
          <p className="text-sm sm:text-base text-[#4A686C] dark:text-[#7A8F8A] font-medium mb-4 md:mb-6" data-id="element-1100">
            24K+ ready templates and UI components
          </p>

          {/* Top row - scrolling right */}
          <div className="relative overflow-hidden mb-4 py-2" data-id="element-1101">
            <div className="flex animate-scroll-right" data-id="element-1102">
              {/* First set of items */}
              {templateItems.map(item => <TemplateCard key={`top-1-${item.id}`} item={item} data-id="element-1103" />)}
              {/* Duplicate set for seamless looping */}
              {templateItems.map(item => <TemplateCard key={`top-2-${item.id}`} item={item} data-id="element-1104" />)}
            </div>
          </div>

          {/* Bottom row - scrolling left */}
          <div className="relative overflow-hidden py-2" data-id="element-1105">
            <div className="flex animate-scroll-left" data-id="element-1106">
              {/* First set of items */}
              {[...templateItems].reverse().map(item => <TemplateCard key={`bottom-1-${item.id}`} item={item} data-id="element-1107" />)}
              {/* Duplicate set for seamless looping */}
              {[...templateItems].reverse().map(item => <TemplateCard key={`bottom-2-${item.id}`} item={item} data-id="element-1108" />)}
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator - Hidden on mobile */}
      <motion.div className="hidden md:flex absolute bottom-4 md:bottom-6 left-1/2 transform -translate-x-1/2 flex-col items-center" initial={{
      y: 0
    }} animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2,
      ease: 'easeInOut'
    }} data-id="element-1109">
        <span className="text-xs sm:text-sm text-[#4A686C] dark:text-[#7A8F8A] mb-2" data-id="element-1110">
          Scroll to explore
        </span>
        <svg className="w-5 h-5 sm:w-6 sm:h-6 text-[#2DB489] dark:text-[#4ED1A0]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1111">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-1112" />
        </svg>
      </motion.div>
    </section>;
};